<template>
  <div class="live">
    <div class="live">
      <div class="title">{{ $t('exhibition.activity') }}</div>
      <div id="swiper-tt" class="exhibitorsLive">
        <!-- 轮播开始 -->

        <!-- swiper -->
        <div v-for="(item, index) in lunItem" :key="index" class="swiper_slide">
          <div class="card" @click="goDetail(item.id)">
            <div class="backImg">
              <img :src="item.backImgUrl" alt="" v-if="item.backImgUrl.substr(0,4)=='http'"/>
              <img :src="baseUrl + item.backImgUrl" alt="" v-else/>
              <span class="bottomImg" @click.stop="collection(item, 4)">
                <img v-if="item.collectStatus" alt="" src="../../../static/collent_yello.png" /><!--显示金色-->
                <img v-else alt="" src="../../../static/collent.png" /><!--显示无色-->
              </span>
            </div>
            <div class="box">
              <div class="activityInfo">
                <div class="text">{{ item.videoTitle }}</div>
                <div class="date">
                  <div class="img">
                    <img alt="" src="../../../static/ico_time.png" />
                  </div>
                  <span>{{ item.date }}{{ $t('common.mobileLive') }}</span>
                </div>

                <div class="address">
                  <div class="img">
                    <img alt="" src="../../../static/ico_address.png" />
                  </div>
                  <!-- <span class="zhanweihao">{{ $t('activity.place') }}</span> -->
                  <span class="number">{{ item.address }}</span>
                </div>
              </div>

              <div class="company">{{ item.company }}</div>
            </div>
          </div>
        </div>
        <!-- 分页 数据大于4条时出现-->
        <div v-if="lunItem.length > 4" slot="pagination" class="swiper-page"></div>
        <!-- 轮播结束 -->
      </div>

      <!--查看更多-->
      <router-link to="active">
        <div class="lookMore">{{ $t('common.viewMore') }}</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { getActivities } from '../../../../api/homePage';
import { forMat } from '../../../../utils/common';

export default {
  name: 'exhibitorsLive',
  data() {
    return {
      //轮播子元素
      lunItem: [
        {
          backImgUrl: require('../../../static/占位-展商-详情.png'),
          videoTitle: '直播内容',
          date: '2021-11-24',
          videoTime: '10:00直播',
          company: '中科万互联网技术有限公司',
        },
      ],
      //收藏按钮
      collent_toggle: false,
      baseUrl: forMat()
    };
  },
  methods: {
    async getActivities() {
      try {
        let { data } = await getActivities();
        const arr = data.data.list.slice(0, 4);
        this.lunItem = arr.map((item, i) => {
          let lunItem = {
            backImgUrl: item.column15, //活动封面
            videoTitle: item.actTitle, //活动名称中文
            date: item.startTime, //开始时间
            company: item.hzExhibitor.companyNameC, //展商名称
            address: item.address,
            id: item.id,
            collectStatus: item.collectStatus,
          };
          return lunItem;
        });
      } catch (e) {
        console.log(e);
      }
    },

    collection(item, type) {
      this.$parent.collection(item, type);
    },

    //跳转至详情
    goDetail(id) {
      this.$router.push({
        name: 'active_detail',
        query: {
          id,
        },
      });
    },
  },
  created() {
    this.getActivities();
  },
};
</script>
<style lang="scss" scoped>
.live {
  width: 100%;
  height: fit-content;
  background-color: white !important;

  .title {
    font-size: 4.8vw;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-align: center;
    padding-top: 7.87vw;
    padding-bottom: 6.93vw;
    box-sizing: border-box;
  }

  .exhibitorsLive {
    width: 100%; //加6*4px是因为轮播内容要有左边距才能在移入时左侧显示出阴影
    margin: 0 auto;
    padding: 4vw 4vw 4vw 4vw;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .swiper_slide {
      width: 49%;
      margin-top: 4vw;
      position: relative;
      .card {
        border: 1px solid #e0e0e0;
        background-color: white;
        cursor: pointer;
        margin: 0 0.4vw; //外边距加 0.4vw显示卡片阴影
        transition: all 0.3s;
        &:hover {
          box-shadow: 0px 0px 3px #9fa3a5;
          .box .text {
            color: #006fb8;
          }
        }

        .backImg {
          box-sizing: border-box;
          width: 100%;
          height: 29.6vw;
          img {
            width: 100%;
            height: 100%;
          }

          .bottomImg {
            position: absolute;
            z-index: 99;
            right: 1.6vw;
            top: 1.6vw;
            width: 6vw;
            height: 6vw;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .box {
          .activityInfo {
            height: 26.2vw;
            padding: 2.6vw;
            box-sizing: border-box;
            font-family: Microsoft YaHei;
            .text {
              width: 38.4vw;
              font-size: 3.7vw;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 4.8vw;
              margin: 0 auto;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              height: 8.5vw;
              transition: all 0.3s;
            }

            .date {
              margin: 0 auto;
              margin-top: 4vw;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              line-height: 3vw;
              color: #666;
              font-family: Microsoft YaHei;
              font-weight: 400;

              .img {
                width: 3vw;
                height: 3vw;

                img {
                  width: 3vw;
                  height: 3vw;
                }
              }

              span {
                margin-left: 1.6vw;
                font-size: 3vw;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
              }
            }

            .address {
              margin-right: 1.3vw !important;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-top: 3.1vw;
              line-height: 3vw;
              font-family: Microsoft YaHei;

              .img {
                width: 3vw;
                height: 3vw;
                img {
                  width: 3vw;
                  height: 3vw;
                }
              }

              span {
                margin-left: 1.6vw;
                font-size: 1.87vw;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
              }
              .zhanweihao {
                white-space: nowrap;
              }
              .number {
                font-size: 3vw;
                color: #666666;
              }
            }
          }

          .company {
            margin: 0 auto;
            padding: 0px 2.6vw;
            border-top: 1px solid #e0e0e0;
            height: 7.47vw;
            margin-top: 2.5vw;

            font-size: 2.6vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 7.3vw;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }
  }

  a {
    display: block;
    text-decoration: none;

    .lookMore {
      width: 48vw;
      height: 9.6vw;
      border: 1px solid #333333;
      border-radius: 1vw;
      margin: 0 auto;
      text-align: center;
      line-height: 4.3vw;
      margin-top: 6.6vw;
      color: #333333;
      font-size: 4.3vw;
      padding-top: 2.6vw;
      padding-bottom: 2.6vw;
      box-sizing: border-box;
      margin-bottom: 10.67vw;
      font-family: Microsoft YaHei;
    }
  }
}
</style>
